//Class qui contient les fontions par défaut des scènes.

import { tags } from '../consts/Tags.js';
import { Colors } from '../consts/Colors.js';
import { Sizes } from '../consts/Sizes.js';
import BurgerMenu from '../prefabs/BurgerMenu.js';

export default class AbstractScene extends Phaser.Scene {
    //Initialisation par défaut, à ajouter dans tous les initialisation
    //Data contient les info des transitions (cf onCompleteHandlerTransitionOUT)
    _init(data) {
        console.log('Start :', this.scene.key, data);

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'game_event',
            event_action: 'Start :' + this.scene.key,
        });
        this.data = {};

        this.game.data.sceneRunning = this.scene.key;

        if (data) {
            // Data à faire passer au besoin
        }
    }

    //Preload de la scene par défaut, initialise les variables utiles
    _preload() {
        this.width = this.cameras.main.width; //Largeur de l'écran
        this.height = this.cameras.main.height; //Hauter de l'écran
        this.SLIDER_WIDTH = 392 * this.scaleX;
        this.scaleX = 2.8;
        this.scaleY = 2;
        this.dim = this.height * 0.05; //Variable pour adapter les images à la hauteur
        this.ratio = Math.min(this.width / 1920, this.height / 1080); //Ratio de l'écran

        this.preTarget = () => {
            console.warn("preTarget() n'est pas défini dans cette scène.");
        };

        this.postTarget = () => {
            console.warn("postTarget() n'est pas défini dans cette scène.");
        };

        if (this.sound && this.sound.stopAll) {
            this.sound.stopAll();
        }
    }

    update() {
        if (!this.video) return;
        if (!this.videoControlsActive) return;

        const nativeVideo = this.video.video; // élément HTMLVideoElement
        const duration = nativeVideo.duration;

        // ⏳ Mise à jour de la barre de buffering
        const buffered = nativeVideo.buffered;
        if (buffered && buffered.length > 0 && isFinite(duration)) {
            const end = buffered.end(buffered.length - 1); // secondes mises en cache
            const percent = Phaser.Math.Clamp(end / duration, 0, 1);
            const w = percent * this.barWidth;

            // ⚠️ pour rexRoundRectangle, préfère setSize/resize
            if (this.bufferBar && w >= 0) {
                this.bufferBar.setSize(w, 8); // ou this.bufferBar.resize(w, 8);
            }
        }

        if (this.isPlaying && !this.isDraging) {
            this.currentTiming = this.video.getCurrentTime();
            this.totalDuration = this.video.getDuration();
            this.slider.value = this.currentTiming / this.totalDuration;
            const progress = this.video.getProgress();
            this.barFill.width = progress * this.barWidth;
        } else if (this.isDraging) {
            const progress = this.video.getProgress();
            const duration = this.video.getDuration();
            const current = progress * duration;
            if (this.currentTimeText) {
                this.currentTimeText.setText(this.formatTime(current));
            }
            this.barFill.width = this.slider.value * this.barWidth;
        }

        if (this.isPlaying) {
            const duration = this.video.getDuration();
            const progress = this.video.getProgress();
            const current = progress * duration;
            if (this.currentTimeText) {
                this.currentTimeText.setText(this.formatTime(current));
            }
            if (this.durationText) {
                this.durationText.setText(this.formatTime(duration));
            }
        }
    }

    getMissionData(data) {
        const lang = this.game.data.lang || 'fr';
        return data.find((entry) => entry.lang === lang) || data[0]; // fallback 'fr'
    }

    getText(sheetName, key) {
        const lang = this.game.data.lang || 'fr';
        const data = this.game.data[`${sheetName}Data`];

        if (data && key in data) {
            const value = data[key];

            // Si string : on remplace les \n
            if (typeof value === 'string') {
                return value.replace(/\\n/g, '\n');
            }

            // Si number ou boolean : on convertit proprement
            if (typeof value === 'number' || typeof value === 'boolean') {
                return String(value);
            }

            // Si null ou undefined
            if (value == null) {
                console.warn(`getText: Valeur nulle pour ${sheetName}.${key}`);
                return '';
            }

            // Autres types (objets, tableaux…)
            console.warn(`getText: Type inattendu pour ${sheetName}.${key}:`, value);
            return JSON.stringify(value); // ou `[${key}]` si tu veux cacher
        }

        console.warn(`Texte manquant : ${sheetName}.${key} (${lang})`);
        return `[${key}]`;
    }

    addBurgerMenu(menuActiveItem) {
        const lang = this.game.data.lang || 'fr';

        this.menuItems = [
            { label: this.getText('Menu', 'menuItem1'), scene: 'Intro' },
            { label: this.getText('Menu', 'menuItem2'), scene: 'Mission1' },
            { label: this.getText('Menu', 'menuItem3'), scene: 'Mission2' },
            { label: this.getText('Menu', 'menuItem4'), scene: 'Mission3' },
            { label: this.getText('Menu', 'menuItem5'), scene: 'Mission4' },
        ];

        if (lang === 'fr') {
            this.menuItems.push({ label: this.getText('Menu', 'menuItem6'), scene: 'Karaoke' });
        }
        this.burgerMenu = this.add.existing(
            new BurgerMenu(
                this,
                this.width - 200,
                50,
                menuActiveItem,
                this.getText('Menu', 'name'),
                this.menuItems,
            ),
        );
        this.burgerMenu.setDepth(100);
    }

    addBouteille(Mission) {
        this.bouteille = this.add
            .image(this.width / 2, this.height / 2, 'bouteilleVide')
            .setOrigin(0.5)
            .setAlpha(0)
            .setScale(0.5);

        // Center the text in the bouteille image
        this.textBouteille = this.add
            .text(
                this.bouteille.x - 100,
                this.bouteille.y,
                this.getText(Mission, 'bouteilleFinaleText'),
                {
                    fontSize: '56px',
                    color: Colors.Text.White,
                    fontFamily: 'Binx',
                    align: 'center',
                    letterSpacing: 10,
                },
            )
            .setOrigin(0.5)
            .setAlpha(0);
    }

    nextScene() {
        var sceneInfo = this.game.data[this.game.data.sceneRunning];
        this.scene.start(sceneInfo.next, this.data);
    }

    clone(element) {
        var clone = Phaser.Utils.Objects.Clone(element);
        this.add.existing(clone);
        return clone;
    }

    createTextElement(x, y, element) {
        let txt = this.add
            .rexTagText(x, y, element.text, {
                fontSize: element.config.size,
                fontFamily: element.config.fontFamily,
                align: element.config.align,
                color: element.config.color,
                backgroundColor: element.config.backColor,
                wordWrap: { width: element.config.width },
                tags: tags,
            })
            .setOrigin(element.config.origin.x, element.config.origin.y);
        return txt;
    }

    showVideoLoading(videoKey, callback = () => {}) {
        // Crée un écran noir semi-transparent de fond
        const blocker = this.add
            .rectangle(this.width / 2, this.height / 2, this.width, this.height, Colors.Elmt.Black)
            .setDepth(10);

        // Texte de chargement
        const loadingText = this.add
            .text(
                this.width / 2,
                this.height / 2,
                this.game.data.lang === 'fr' ? 'Préparation de la vidéo...' : 'Loading video ...',
                {
                    fontSize: Sizes.Text.h3,
                    color: Colors.Text.White,
                    fontFamily: 'Monteserrat',
                },
            )
            .setOrigin(0.5)
            .setDepth(11);

        // Ajout de la vidéo (ne la joue pas tout de suite)
        const tempVideo = this.add
            .video(this.width / 2, this.height / 2, videoKey)
            .setOrigin(0.5)
            .setDepth(9)
            .setAlpha(0); // on la cache

        // Une fois que la vidéo est prête à jouer
        tempVideo.video.addEventListener('canplaythrough', () => {
            loadingText.destroy();
            blocker.destroy();
            tempVideo.destroy();

            // Lancer le callback pour ensuite appeler `showVideo(videoKey)`
            callback();
        });

        // Lance le chargement réel (sans affichage pour l'instant)
        tempVideo.setPaused(true);
        tempVideo.setMute(true); // on mute pour éviter tout souci de lecture bloquée
        tempVideo.play(); // nécessaire pour déclencher le buffering
        tempVideo.pause();
    }

    showVideo(videoKey) {
        this.videoControlsActive = true;
        this.isDraging = false;
        this.isPlaying = false;
        this.isPaused = false; // On démarre en pause
        this.allControls = [];
        this.videoReady = false;

        this.barWidth = 392 * this.scaleX;
        this.barY = 272 * this.scaleY + 32;
        this.barX = 88 * this.scaleX;
        const leftX = this.width / 2 - this.barWidth / 2;

        const blocker = this.add.rectangle(
            this.width / 2,
            this.height / 2,
            this.width,
            this.height,
            Colors.Elmt.Black,
        );

        // 📹 1. Ajoute la vidéo
        this.video = this.add.video(0, 0, videoKey).setOrigin(0.5).setDepth(1);

        // 2. On centre la vidéo au milieu du canvas
        this.video.setPosition(this.width / 2, this.height / 2);
        this.video.setScale(0.9);
        this.video.setPosition(this.width / 2, this.height / 2);
        this.video.setPaused(true);

        this.video.video.addEventListener('loadedmetadata', () => {
            const duration = this.video.getDuration();
            this.durationText.setText(this.formatTime(duration));
            this.currentTimeText.setText(this.formatTime(0));

            // Maintenant que la vidéo est prête, on peut tout afficher
            this.currentTimeText.setVisible(true);
            this.durationText.setVisible(true);
            this.barretime.setVisible(true);
            this.sliderLine.setVisible(true);
            this.sliderButton.setVisible(true);
            this.barFill.setVisible(true);
            this.bufferBar.setVisible(true);
            this.buttonReculer.setVisible(true);
            this.buttonAvancer.setVisible(true);

            this.videoReady = true;
        });

        // ▶️ 3. Bouton Play au centre
        this.startButton = this.add
            .image(this.width / 2, this.height / 2, 'video-start')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .setDepth(3);
        this.startButton.setAlpha(1);
        this.allControls.push(this.startButton);

        // 🕹️ Animation au survol du bouton Play
        this.startButton.on('pointerover', () => {
            this.tweens.add({
                targets: this.startButton,
                scale: 1.1,
                duration: 200,
                ease: 'Sine.easeInOut',
            });
        });

        this.startButton.on('pointerout', () => {
            this.tweens.add({
                targets: this.startButton,
                scale: 1,
                duration: 200,
                ease: 'Sine.easeInOut',
            });
        });

        // Clique sur le bouton Play pour démarrer la vidéo
        this.startButton.on('pointerdown', () => {
            if (!this.videoReady) return;
            this.video.play();
            this.isPlaying = true;
            this.video.setMute(false);
            this.video.setVolume(1); // au cas où
            this.startButton.setAlpha(0); // Cache le bouton play
            this.startButton.setDepth(-1);
            // this.allControls.forEach((control) => control.setVisible(true));

            this.video.once('play', () => {
                const duration = this.video.getDuration();
                this.durationText.setText(this.formatTime(duration));
            });
        });

        // ⏱️ Texte durée
        this.currentTimeText = this.add
            .text(473 * this.scaleX - 65, 273 * this.scaleY - 20, '0:00', {
                fontSize: Sizes.Text.p,
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setDepth(20)
            .setVisible(false);
        this.allControls.push(this.currentTimeText);

        this.barretime = this.add
            .text(473 * this.scaleX - 30, 273 * this.scaleY - 20, '/', {
                fontSize: Sizes.Text.p,
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setDepth(20)
            .setVisible(false);
        this.allControls.push(this.barretime);

        this.durationText = this.add
            .text(473 * this.scaleX, 273 * this.scaleY - 20, '0:00', {
                fontSize: Sizes.Text.p,
                color: '#fff',
                fontFamily: 'Monteserrat',
            })
            .setOrigin(0.5)
            .setDepth(20)
            .setVisible(false);
        this.allControls.push(this.durationText);

        this.sliderLine = this.add
            .rexRoundRectangle(this.width / 2, this.barY, this.barWidth, 8, 4, Colors.Elmt.White)
            .setAlpha(0.5)
            .setDepth(20)
            .setVisible(false);
        this.allControls.push(this.sliderLine);
        this.barFill = this.add
            .rexRoundRectangle(this.barX, this.barY, 0, 8, 4, Colors.Elmt.White)
            .setOrigin(0, 0.5)
            .setDepth(20)
            .setVisible(false);
        this.allControls.push(this.barFill);
        // Buffering pour la vidéo
        this.bufferBar = this.add
            .rexRoundRectangle(this.barX, this.barY, 0, 8, 4, Colors.Elmt.Gray)
            .setOrigin(0, 0.5)
            .setAlpha(0.8)
            .setDepth(19) // sous le fill, au-dessus du fond
            .setVisible(false);
        this.allControls.push(this.bufferBar);

        this.sliderLine.setSize(this.barWidth, this.sliderLine.height);
        this.sliderLine.setInteractive({ useHandCursor: true });
        this.sliderLine.on('pointerdown', (event) => {
            let a = event.x;
            let b = this.sliderLine.x;
            let c = a - b;
            let value = (c + this.barWidth / 2) / this.barWidth;
            this.barFill.width = value * this.barWidth;
            this.slider.value = value;
            this.video.seekTo(value);
        });
        this.sliderButton = this.add
            .circle(this.width / 2 - this.barWidth / 2, this.barY, 30, Colors.Elmt.White)
            .setInteractive({ useHandCursor: true })
            .setAlpha(1)
            .setDepth(20)
            .setVisible(false);
        this.allControls.push(this.sliderButton);
        this.sliderButton.setStrokeStyle(4, Colors.Elmt.White);
        this.sliderButton.on('pointerdown', () => {
            this.isDraging = true;
            this.isPlaying = false;
            this.video.setPaused(true);
        });
        /* this.sliderButton.on("pointerup", () => {
      this.isDraging = false;
      if (this.video.isPaused()) {
        this.isPlaying = false;
        this.video.setPaused(true);
      } else {
        this.isPlaying = true;
        this.video.setPaused(false);
      }
    }); */

        this.sliderButton.on('pointerup', () => {
            this.isDraging = false;
            this.isPlaying = true;
            this.video.setPaused(false); // 🔧 on force la reprise
        });

        /* this.input.on("pointerup", () => {
      if (this.isDraging) {
        this.isDraging = false;
        this.isPlaying = true;
        this.video.setPaused(false);
      }
    }); */

        this.input.on('pointerup', () => {
            if (this.isDraging) {
                this.isDraging = false;
                this.isPlaying = true;
                this.video.setPaused(false);
            }
        });

        this.slider = this.plugins.get('rexSlider').add(this.sliderButton, {
            endPoints: [
                { x: this.sliderLine.x - this.barWidth / 2, y: this.sliderLine.y },
                { x: this.sliderLine.x + this.barWidth / 2, y: this.sliderLine.y },
            ],
            value: 0,
            enable: true,
            valuechangeCallback: (value) => {
                if (this.isDraging) {
                    this.video.seekTo(value);
                }
            },
        });

        // 📥 Sur fin de la vidéo
        let hasEnded = false;

        this.video.once('complete', () => {
            hasEnded = true;
            this.postTarget(this);
            this.videoControlsActive = false;
            this.video?.destroy();
            this.startButton?.destroy();
            this.allControls.forEach((control) => control?.destroy());
        });

        // Clique sur la vidéo pour la mettre en pause ou reprendre
        this.video.setInteractive();
        this.video.on('pointerdown', () => {
            if (hasEnded) return;
            // Si la vidéo est en pause, la reprendre
            if (this.video.isPaused()) {
                this.video.resume();
                this.startButton.setAlpha(0); // Cacher le bouton Play
            } else {
                // Sinon, mettre la vidéo en pause
                this.bufferBar.setVisible(true);
                this.video.pause();
                this.startButton.setAlpha(1); // Montrer le bouton Play
            }
        });

        this.buttonReculer = this.add
            .image(32 + 32, this.height - 32 - 32, 'video-reculer')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.preTarget(this);
            })
            .setVisible(false)
            .setDepth(20);
        this.allControls.push(this.buttonReculer);

        this.buttonAvancer = this.add
            .image(this.width - 32 - 32, this.height - 32 - 32, 'video-avancer')
            .setOrigin(0.5)
            .setInteractive({ useHandCursor: true })
            .on('pointerdown', () => {
                this.videoControlsActive = false;
                this.video.destroy();
                this.startButton.destroy();
                this.allControls.forEach((control) => control.destroy());
                this.postTarget(this);
            })
            .setVisible(false)
            .setDepth(20);
        this.allControls.push(this.buttonAvancer);
    }

    formatTime(seconds) {
        if (!Number.isFinite(seconds) || seconds < 0) {
            return ''; // ou '' si tu préfères rien afficher
        }
        const minutes = Math.floor(seconds / 60);
        const sec = Math.floor(seconds % 60);
        return `${minutes}:${sec.toString().padStart(2, '0')}`;
    }
}
